(function(w, $, _) {

    const assetId = '~/Parts/Views/Site/SiteCart.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {
        
        const $mainPanel = $('#' + ctx.mainPanelID);
        const popupTemplate = ctx.popupTemplate;
        const detailedCartInfo = JSON.parse(ctx.detailedCartInfoJSON);
        const settings = ctx.settings;
        const labels = ctx.labels;
        const urls = ctx.urls;
        const refreshHashSessionName = '__' + ctx.mainPanelID + 'Hash__';
        let $timer;

        const freeShippingSettings = w.globalSettings.freeShippingMessageSettings;

        const estore = w.PublicEStore;

        const classes = {
            popup: 'js-site-cart-popup',
            popupItem: 'js-site-cart-popup-item',
            popupExportToExcel: 'js-site-cart-popup-export-to-excel',
            popupGoToShopCart: 'js-site-cart-popup-go-to-shopcart',
            popupContinueShopping: 'js-site-cart-popup-continue-shopping',
            popupRemoveAll: 'js-site-cart-popup-remove-all',
            popupRemoveItem: 'js-site-cart-popup-item-remove',
            popupQuantityInput: 'js-quantity-input',
            popupQuantityUp: 'js-quantity-up',
            popupQuantityDown: 'js-quantity-down',
        };

        //Main panel child elements
        const $cartLink = $mainPanel.find('.js-show-cart-link'),
            $popupPanel = $mainPanel.find('.' + classes.popup),
            $shopCartPanel = $mainPanel.find('.ShoppingListPanel'),
            $wishListPanel = $mainPanel.find('.WishListPanel'),
            $refreshHash = $mainPanel.find('.js-refreshHash');

        //disable bfcashe
        const isFirefox = typeof InstallTrigger !== "undefined";
        const isSafari = /constructor/i.test(window.HTMLElement) || (function(p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window["safari"] || (typeof safari !== "undefined" && safari.pushNotification));
        if (isFirefox) { window.onunload = function() {}; };
        if (isSafari) { window.onpageshow = function(event) { if (event.persisted) { window.location.reload(); } }; };

        $(function() {
            //refresh shopcart if browsers' 'go back' button was pressed
            const sessionRefreshHash = parseInt(sessionStorage.getItem(refreshHashSessionName));
            const refreshHash = parseInt($refreshHash.val());
            if (sessionRefreshHash !== refreshHash) {
                shopCartHandler();
            }

            // Subscribe to shopcart events
            if ($shopCartPanel.length === 1) {
                estore.subscribe(estore.channels.callback.shopCart, shopCartHandler);
            }

            // Subscribe to shopping list events
            if ($wishListPanel.length === 1) {
                estore.subscribe(estore.channels.callback.shoppingList, shoppingListHandler);
            }

            // Setup popup
            if (settings.showPopup) {
                buildPopup(detailedCartInfo);
                // Show popup on hovering cart link
                $cartLink.mouseenter(function() {
                    togglePopup(true);
                });
            }
        });

        function shopCartHandler(event, contract) {

            let action = null;

            if (contract && contract.result && contract.result.detailedCartInfo) {
                const detailed = contract.result.detailedCartInfo;
                const summary = detailed.summary;
                const transId = contract.transactionID;
                action = contract.action;

                updateInfoBlock($shopCartPanel, summary, transId);

                if (settings.showPopup) {
                    buildPopup(detailed);
                }
            } else {
                const cartInfoDeferred = settings.showPopup
                    ? estore.getSiteCartInfo(null, true, settings.popupImageWidth, settings.popupImageModification)
                    : estore.getCartInfo(null, true);
                const successCallback = settings.showPopup ? detailedCartInfoSuccessCallback : cartInfoSuccessCallback;

                $.when(cartInfoDeferred).then(successCallback, showError);
            }

            // show popup when shopCart callback was fired
            if (action && settings.showPopup) {
                const interestedActions = ['addtocart', 'removefromcart', 'emptycart'];
                if (_.contains(interestedActions, action)) {
                    togglePopup(true);
                }
            }

            // add a class to style buying state
            if (action && action === 'addtocart') {
                $cartLink.addClass('is-bought');
                setTimeout(function() {
                        $cartLink.removeClass('is-bought');
                    },
                    1000);
            }

        }

        function shoppingListHandler() {
            $.when(estore.getShoppingListInfo(0, null, true)).then(wishListInfoSuccessCallback, showError);
        }

        function detailedCartInfoSuccessCallback(detailedCartInfoContract) {
            updateInfoBlock($shopCartPanel,
                detailedCartInfoContract.result.detailedCartInfo.summary,
                detailedCartInfoContract.transactionID);
            buildPopup(detailedCartInfoContract.result.detailedCartInfo);
        }

        function cartInfoSuccessCallback(cartInfoContract) {
            updateInfoBlock($shopCartPanel, cartInfoContract.result.cartInfo, cartInfoContract.transactionID);
        }

        function wishListInfoSuccessCallback(wishListInfoContract) {
            updateInfoBlock($wishListPanel, wishListInfoContract.result.cartInfo, wishListInfoContract.transactionID);
        }

        function buildPopup(data) {
            if ($popupPanel.length === 1 && popupTemplate) {
                //Store scroll position
                let itemsParent = $popupPanel.find('.' + classes.popupItem).first().parent();
                const currentScrollTop = itemsParent && itemsParent.length > 0 ? itemsParent[0].scrollTop : 0;

                $popupPanel.empty();

                const popupHtml = _.template(popupTemplate,
                    {
                        data: data,
                        labels: labels,
                        settings: settings,
                        urls: urls,
                        freeShippingSettings: freeShippingSettings
                    });

                $popupPanel.append(popupHtml);

                //Restore scroll position
                if (currentScrollTop > 0) {
                    itemsParent = $popupPanel.find('.' + classes.popupItem).first().parent();
                    if (itemsParent && itemsParent.length > 0) {
                        itemsParent[0].scrollTop = currentScrollTop;
                    }
                }

                $popupPanel.find('.' + classes.popupExportToExcel).click(function(evt) {
                    evt.preventDefault();
                    window.location = urls.exportExcelUrl;
                });

                $popupPanel.find('.' + classes.popupGoToShopCart).click(function(evt) {
                    evt.preventDefault();
                    window.location = urls.shopCartUrl;
                });

                $popupPanel.find('.' + classes.popupContinueShopping).click(function(evt) {
                    evt.preventDefault();
                    togglePopup(false);
                });

                $popupPanel.find('.' + classes.popupRemoveAll).click(function(evt) {
                    evt.preventDefault();
                    $popupPanel.addClass('loading');
                    $.when(estore.emptyCart())
                        .always(function() {
                            $popupPanel.removeClass('loading');
                        })
                        .fail(showError);
                });

                $popupPanel.find('.' + classes.popupRemoveItem).click(function(evt) {
                    evt.preventDefault();
                    const $itemContainer = $(this).closest('.' + classes.popupItem);
                    const tempOrderLineId = $itemContainer.data('tolid');
                    $itemContainer.addClass('loading');
                    $.when(estore.removeFromCart(tempOrderLineId))
                        .always(function() {
                            $itemContainer.removeClass('loading');
                        })
                        .fail(showError);
                });

                $popupPanel.find('.' + classes.popupQuantityInput).change(function() {
                    let quantity = $(this).val();

                    if (isUnsupportedQuantity(quantity)) {
                        quantity = 1;
                        $(this).val('1');
                    }

                    updateQuantity(quantity, $(this));
                });

                $popupPanel.find('.' + classes.popupQuantityUp).click(function(evt) {
                    evt.preventDefault();

                    const $quantityInput = $(this).closest('.' + classes.popupItem).find('.' + classes.popupQuantityInput);
                    let quantity = parseFloat($quantityInput.val().toString().replace(/,/g, "."));

                    quantity = ++quantity;

                    if (!isUnsupportedQuantity(quantity)) {
                        $quantityInput.val(quantity.toString().replace(/\./g, ","));
                        updateQuantity(quantity, $(this));
                    }
                });


                $popupPanel.find('.' + classes.popupQuantityDown).click(function(evt) {
                    evt.preventDefault();

                    const $quantityInput = $(this).closest('.' + classes.popupItem).find('.' + classes.popupQuantityInput);
                    let quantity = parseFloat($quantityInput.val().toString().replace(/,/g, "."));

                    quantity = --quantity;

                    if (!isUnsupportedQuantity(quantity)) {
                        $quantityInput.val(quantity.toString().replace(/\./g, ","));
                        updateQuantity(quantity, $(this));
                    }
                });

                function isUnsupportedQuantity(quantity) {
                    const qty = parseFloat(quantity.toString().replace(/,/g, "."));
                    return qty <= 0.0;
                }

                function updateQuantity(quantity, $source) {

                    if ($timer) {
                        w.clearTimeout($timer);
                        $timer = null;
                    }

                    const $itemContainer = $source.closest('.' + classes.popupItem);
                    const tempOrderLineId = $itemContainer.data('tolid');

                    $timer = w.setTimeout(function() { updateQuantityRefresh(tempOrderLineId, quantity) }, 300);
                }

                function updateQuantityRefresh(tempOrderLineId, quantity) {
                    $popupPanel.addClass('loading');

                    const qty = quantity.toString().replace(/,/g, ".");

                    $.when(estore.updateCartQuantity({ tempOrderLineId: tempOrderLineId, quantity: qty }))
                        .fail(function(error) {
                            showNotification(error.message, 'error');
                        })
                        .always(function() {
                            $popupPanel.removeClass('loading');
                        });
                }

            }
        }

        function togglePopup(showOrHide) {
            $popupPanel.toggleClass('hidden', !showOrHide);
            if (showOrHide) {
                $popupPanel.removeClass('hidden');
                // If popup is shown, attach global click handler to hide popup
                $('html').on('click.sitecart.popup',
                    function(evt) {
                        if ($(evt.target).parents().index($popupPanel) === -1) {
                            togglePopup(false);
                        }
                    });
            } else {
                $popupPanel.addClass('hidden');
                // Deattach global click handler
                $('html').off('click.sitecart.popup');
            }
        }

        function updateInfoBlock(block, cartInfo, refreshHashValue) {
            const $section = $(block);
            if ($section.length > 0 && !_.isEmpty(cartInfo)) {
                $section.find('.ProdCount').text(Math.floor(cartInfo.productCount));
                $section.find('.TotalPrice').text(cartInfo.formattedTotalPrice);
                $section.find('.TotalVAT').text(cartInfo.formattedTotalVAT);
                $section.find('.TotalDiscount').text(cartInfo.formattedTotalDiscount);
                if (cartInfo.productCount > 0) {
                    $section.removeClass('empty');
                    $section.addClass('notEmpty');
                } else {
                    $section.addClass('empty');
                    $section.removeClass('notEmpty');
                }
            }
            sessionStorage.setItem(refreshHashSessionName, refreshHashValue);
            $refreshHash.val(refreshHashValue);
        }
    }

    function showNotification(message, notificationType) {
        var notificationChannel = typeof (notificationType) === 'string' && notificationType ? 'notification.' + notificationType : 'notification';
        w.PubSub.publish(notificationChannel, message);
    }

    function showError(errContract) {
        if (errContract) {
            var errorMessage;
            if (typeof errContract === 'string') {
                errorMessage = errContract;
            } else {
                errorMessage = errContract.result && errContract.result.items[0] ? errContract.result.items[0].message : errContract.message;
            }

            console.error('Failed to update shopping cart information. %s', errorMessage); // Don't think we need to show this message to the user. This message can confuse the users.
        }
    }
})(window, jQuery, _);